import { IAgent } from '@/types';
import { getUrl } from '@/utils/api';

function useAgents(filter?: string) {
  let url = `v1/agents`;
  if (filter) {
    url += `?query=${filter}`;
  }
  const query = getUrl(url);
  return {
    ...query,
    data: query.data as IAgent[],
  };
}

export default useAgents;
